/**
 * Message edits are stored as PubNub message actions (type 'edit'), since published
 * messages cannot be changed. Only the original sender's edits count; the newest wins.
 * `at` is the action timetoken, so edits arriving out of order resolve correctly.
 */
export const EDIT_ACTION_TYPE = 'edit';

export function applyMessageEdit(message: any, actorId: string, text: any, at: number): boolean {
  if (!message || typeof text !== 'string' || !text.trim()) return false;
  if (!actorId || actorId !== message._sender?.userId) return false;
  if (Number(message.editedAt || 0) >= at) return false;
  message.message = text;
  message.editedAt = at;
  return true;
}
